<template>
  <nna-container>
    <div class="align-middle">  
      <md-icon class="md-size-4x">check_circle</md-icon>
      <h1 class="md-title">Operazione Riuscita</h1>
      <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->
      <md-button class="md-raised md-primary mt-7" md-align="center" @click="$router.push({ name: 'auth' })">Login</md-button>
    </div>
  </nna-container>  
</template>

<script>
export default {
  name: 'SignupDone',
  mounted() {
    
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/auth/signup/pages/SignupDone.vue